var XPortal = XPortal || {};

XPortal.SectionDisplayRules = (function () {
    const self = {
        _isServerSideProcessing: false, //true - Server-side processing, false - Client-side processing (of sections rules)
        model: [],
        modelsToRefresh: [],
        relations: [],
        _section: 'xsection',
        _sectionSelector: '.xsection',
        _processDRUrl: '/umbraco/Surface/Detail/DisplaySections',
        toUpdateClass: "drules-click-first",
        processDRTimeout: null,
        Init: function (selector) {
            self.Processing.Init(selector);
        },
        CalculateFormattingRules: function (ginfo, e) {
            const records = ginfo && ginfo.kgrid ? ginfo.kgrid.dataSource.data() : null;
            if (!records || !records.length) return;
            const frsttgs = ginfo.kgrid.options.FRules || {IsEnabled:false,Items:[]};
            const formatRules = frsttgs.Items;
            if (!frsttgs.IsEnabled || !formatRules || !formatRules.length || !records) return;
            try {
                self.updateRelatedModel(ginfo.modelName, formatRules, "#" + ginfo.id);

                records.forEach((x, ix) => {
                    const $tr = $(ginfo.kgrid.table).find(`tr.k-master-row[data-uid='${x.uid}']`);
                    const $litem = ginfo.list.find(`.entity-cvitem[data-uid='${x.uid}'] .entity-cvitem-cnt`);
                    if (!$tr.length && !$litem.length) return;
                    const model = Object.assign({}, x, { ModelName: ginfo.modelName, NodeId: ginfo.nodeId });
                    formatRules.forEach(r => {
                        let rulesResult = false;
                        const $td = $tr.find('td');

                        if (r.IsEnabled && r.Rules && r.Rules.length) {
                            rulesResult = XPortal.SectionDisplayRules.Processing.areRulesTrue(model, [...r.Rules], null, true, true);
                        }

                        let updatedTdClases = r.CssClasses;
                        let updatedTdRemoveClases = r.CssClasses;
                        const borderClass = "fr-td_border";
                        const borderStyle = "border:";
                        if (r.StyleCss && r.StyleCss.includes(borderStyle)) {
                            updatedTdClases = `${r.CssClasses} ${borderClass}`;
                        } 

                        $td.each(function () {
                            $(this).removeClass(updatedTdRemoveClases);
                            const tdStyle = $(this).attr("style") || "";
                            if (rulesResult) {
                                $(this).addClass(updatedTdClases);
                                $(this).attr("style", tdStyle + ";" + r.StyleCss);
                            }
                            else {
                                $(this).removeClass(updatedTdClases);
                                $(this).attr("style", tdStyle.replace(r.StyleCss, ""));
                            }
                        });

                        const liStyle = $litem.attr("style") || "";
                        if (rulesResult) {
                            $litem.addClass(updatedTdClases);
                            $litem.attr("style", liStyle + ";" + r.StyleCss);

                            const colorCss = XPortal.Utils.checkIfColorCssInString(r.StyleCss)
                            if (colorCss) {
                                $litem.find('.entity-fld-val').attr("style", colorCss)
                            } 
                        } else {
                            $litem.removeClass(updatedTdClases);
                        }
                    });
                });
            } catch (e) {
                if (console) console.warn('rule formating calc error!', e);
            }
        },
        updateRelatedModel: function (modelName, frModel, selector) {
            const res = ((self.relations[modelName] || {}).items || []).concat(XPortal.SectionDisplayRules.Processing.GetFRelatedFields(frModel, modelName));
            self.relations[modelName] = { items: _.uniq(res, x => x.key), selector };
        },
        initModel: function (imodel, action) {
            if (imodel && imodel.model) imodel.model.drInProcess = true;
            const model = imodel.model;
            const nodeId = model.NodeId;
            const entityUId = imodel.entity.UniqueId;
            self.model = self.model.filter(x => x.NodeId != nodeId);
            const reqItem = {
                NodeId: nodeId,
                ModelName: model.modelName,
                EntityUId: entityUId,
                IsUpdated: true,
                PData: getParentData(model.ParentInfo),
                SectionsData: getSectionsData(nodeId),
                ModifiedFields: initFields(action, entityUId),
                Selector: model.selector
            };
            self.model.push(reqItem);

            refreshTimeout(true);
        },
        hideAllSections: function (model) {
            $(model.model.selector).find(".xsection[data-edit-type='xdetailssection']").addClass("d-none opacity-0");
        },
        isNeededToBeTracked: function (action, model) {
            const r = XPortal.Events.helpers.isOneOfFields(action, ...getInfluenceFieldsByModel(model));
            const cfname = action && action.field && action.field.field ? action.field.field.toLowerCase() : false;
            if (!cfname || cfname.length < 1) return r;
            const modelNameLC = action.model.toLowerCase();
            for (let i in self.relations) {
                if (self.relations[i].items.filter(x => x.fname.toLowerCase() == cfname && x.modelName.toLowerCase() == modelNameLC).length)
                    if (!self.modelsToRefresh.includes(i)) self.modelsToRefresh.push(i);
            }

            return r || self.modelsToRefresh.length;
        },
        updateModel: function (model, action) {
            if (!XPortal.SectionDisplayRules.isNeededToBeTracked(action, model)) return;
            const afield = action.field;
            const afieldName = afield && afield.field ? afield.field.toLowerCase() : null;
            self.model.forEach((item, i) => {
                if (item.EntityUId != model.entity.UniqueId) return;
                if (afieldName) updateModifiedField(item.ModifiedFields, afieldName, afield);
                item.IsUpdated = true;
            });

            refreshTimeout();
        }
    };
    function processRules(focusFirst) {

        self.modelsToRefresh.forEach((item, i) => {
            const model = self.model.find(x => x.ModelName.toLowerCase() == item.toLowerCase());
            if (model) model.IsUpdated = true;
            if (!model && item.startsWith("GM.")) {
                let $grid = $(self.relations[item].selector);
                if ($grid.length) {
                    const ginfo = XPortal.Grid.GetGridInfo($grid);
                    ginfo.kgrid.dataSource.read();
                    ginfo.kgrid.refresh();
                }
            }
            self.modelsToRefresh.splice(i, 1);
        });
        if (!self.model.find(x => x.IsUpdated)) return;
        if (self._isServerSideProcessing) return processOnServer(focusFirst);
        return processOnClient(focusFirst);
    };
    function processOnClient(focusFirst) {
        XPortal.SectionDisplayRules.Processing.Process(self.model).then((state) => {
            if (!state.IsValid) return showError();
            updateSectionsData(state.SectionsDataUpd)
            updateSections(focusFirst);

            setRequestsAndFieldsNotUpdated();
        }, function (textStatus) {
            showError([textStatus]);
        });
    };
    function processOnServer(focusFirst) {
        XPortal.Utils.APIPost(self._processDRUrl, self.model, { contentType: "application/json" })
            .then(function (response) {
                if (!response.IsValid) showError(response.Errors);

                updateSectionsData(response.SectionsDataUpd);
                updateSections(focusFirst);

                setRequestsAndFieldsNotUpdated();
            })
            .fail(function (jqXHR, textStatus) {
                showError([textStatus]);
            });
    };
    function initFields(action, entityUId) {
        const res = [];
        self.model.forEach((item, i) => {
            if (item.EntityUId != entityUId) return;
            item.ModifiedFields.forEach((x, i) => {
                const xcp = Object.assign({}, x);
                xcp.IsUpdated = true;
                res.push(xcp);
            });
        });

        const tres = [];
        action.entity.Fields.forEach((x, i) => {
            let isExists = false;
            const name = x.Name.toLowerCase();
            res.forEach((rx, i) => { if (name == rx.Name.toLowerCase()) isExists = true; });
            if (isExists) return;

            tres.push({ Name: x.Name, Type: x.ftype, Value: x.StringValue, IsUpdated: true });
        });
        return res.concat(tres);
    };
    function updateModifiedField(modified, lcFieldName, afield) {
        const mfield = modified.find(x => x.Name.toLowerCase() == lcFieldName);
        if (mfield) {
            mfield.Value = afield.data;
            mfield.IsUpdated = true;
        }
        else modified.push({ Name: afield.field, Type: afield.ftype, Value: afield.data, IsUpdated: true });
    };
    function updateSections(focusFirst) {
        self.model.forEach((x, i) => {
            if (!x.IsUpdated) return;
            x.SectionsData.forEach((y, i) => { updateSection(y, focusFirst); });

            focusValidationErrorOnNeededSection(x);
            //update grids action buttons
            $(window).trigger('resize');
            setTimeout(() => $(".xsection").removeClass("opacity-0"), 150);
            setDRInProcessByNodeId(x.NodeId, false);
            updateRelationsModel(x.SectionsData, x.ModelName, x.Selector);
        });
    };
    function updateRelationsModel(sdata, modelName, selector) {
        let res = [];
        sdata.forEach((x, i) => {
            if (x.RelatedFields && x.RelatedFields.length)
                res = res.concat(x.RelatedFields.map(x => x.fname ? x : { fname: x, modelName, key: x + modelName }));
        });
        self.relations[modelName] = { items: _.uniq(res, x => x.key), selector };
    }
    function setDRInProcessByNodeId(nodeId, value) {
        const modelName = XPortal.Store.GetModelByNodeId(nodeId);
        const model = XPortal.Store.GetModelByName(modelName);
        if (model && model.model) model.model.drInProcess = value;
    };
    function focusValidationErrorOnNeededSection(detailData) {
        const $validationErrors = $(XPortal.EditForm._fieldSelector + " ~ .xfield-validation.field-validation-error");
        if (!$validationErrors.length) updateDropDownsAndTabs(detailData);
        else $validationErrors.first().parent().find(".detail-field").focus();
    };
    function updateDropDowns($detail) {
        $detail.find(".xsection-dropdown").each(() => {
            const $dd = $(this);
            const $uls = $dd.find(`.dropdown-menu.${self.toUpdateClass}`);
            if (!$uls.length) return;
            let hideDD = false;
            $uls.each(() => {
                const $menuCnt = $(this);
                $menuCnt.removeClass(`${self.toUpdateClass}`);

                const $firstItem = $menuCnt.children(':not(".d-none")').first();
                if (!$firstItem.length) {
                    hideDD = true;
                    return;
                }
                $firstItem.simulateClick();
                $firstItem.find('.di-content').simulateClick();
            });
            hideDD ? $dd.addClass("d-none") : $dd.removeClass("d-none");
        });
    };
    function updateTabs($detail) {
        $detail.find(".xsection-tab").each(() => {
            const $ts = $(this);
            const $uls = $ts.find(`.nav-tabs.${self.toUpdateClass}`);
            if (!$uls.length) return;
            $uls.each(() => {
                const $tabCnt = $(this);
                $tabCnt.removeClass(`${self.toUpdateClass}`);

                const $firstItem = $tabCnt.closest('.nav-tabs').children(':not(".d-none")').first();
                if (!$firstItem.length) return;
                $firstItem.simulateClick();
                $firstItem.find('.nav-link').simulateClick();
            });
        });
    };
    function updateDropDownsAndTabs(detailData) {
        const $detail = $(detailData.Selector);
        updateDropDowns($detail);
        updateTabs($detail);
    };
    function updateSection(isection, focusFirst) {
        const $section = $(`${self._sectionSelector}#${isection.Id}`);
        const $sectionParent = $section.parents(self._sectionSelector).first();
        const $sectionBgDecoration = $section.find('>.xbgdecoration-wrap');
        const $sectionHeader = $sectionBgDecoration.find('>.block-header');

        if ($sectionParent.hasClass('xsection-dropdown')) {
            displaySectionBy("dropdown", isection, $section, focusFirst);
        } else if ($sectionParent.hasClass('xsection-tab')) {
            displaySectionBy("tab", isection, $section, focusFirst);
        } else if ($sectionParent.hasClass('xsection-accordion')) {
            displaySectionBy("accordion", isection, $section, focusFirst);
        } else if ($section.hasClass(self._section)) {
            displaySectionBy("", isection, $section);
        }

        //detail fields
        if (isection.IsVisible) {
            if (!$section.closest(".d-none").length)
                $section.find(">.xbgdecoration-wrap > .section-content > .xcontent > div.dr-field-set .detail-field").removeClass("dr-invisible");
        }
        else { $section.find(".detail-field").addClass("dr-invisible"); }

        //gauges
        if (isection.IsVisible) $section.find("> .xcontent > .dr-gauge").each(() => { XPortal.Measure.reInit($(this)); });
        //fr
        let updatedSectionClases = "";
        let updatedSectionRemoveClases = "";
        const borderClass = "xbgdecoration-wrap_padding";
        const borderStyle = "border:";
        const backgroundStyle = "background";
        if (isection.Style.includes(borderStyle) || isection.Style.includes(backgroundStyle)) {
            updatedSectionClases = `${isection.Classes} ${borderClass}`;
        } else {
            updatedSectionRemoveClases = `${isection.RemoveClasses} ${borderClass}`;
        }

        $sectionBgDecoration
            .attr("style", `${isection.OrgStyle} ${isection.Style}`)
            .addClass(updatedSectionClases)
            .removeClass(updatedSectionRemoveClases);

        // if is section styling apply color only to title, subtitle and description
        const $headerElements = $sectionHeader.find('.block-header-description, .block-header-subtitle, .block-header-title, .block-header-title a')

        $headerElements.each(function () {
            $(this)
                .attr("style", `${isection.ColorCss}`)
                .addClass(isection.Classes)
                .removeClass(isection.RemoveClasses);
                $(this).find('i').attr("style", `${isection.ColorCss}`);
        });

    };
    function displaySectionBy(viewType, isection, $section, focusFirst) {
        const isVisible = isection.IsVisible;
        isVisible ? $section.removeClass("d-none") : $section.addClass("d-none");
        XpandUploadControl.prototype.ImagesInit($section);

        if (viewType == "dropdown") {
            const $content = $section.closest('.item-content');
            const newClass = $content.attr('class');
            const id = newClass.substring(0, newClass.indexOf(' '));
            const $dropdownLink = $('.di-content[data-target="' + id + '"]');
            const $dropdownItem = $dropdownLink.closest('.dropdown-item');
            const $menuCnt = $dropdownLink.closest('.dropdown-menu');

            if (focusFirst || (!isVisible && !$content.is(".d-none")))
                $menuCnt.addClass(`${self.toUpdateClass}`);

            isVisible ? $dropdownItem.removeClass("d-none") : $dropdownItem.addClass("d-none");
        };

        if (viewType == "tab") {
            const $content = $section.closest('.tab-pane');
            const id = $content.attr('aria-labelledby');
            const $tabLink = $('#' + id);
            const $tabItem = $tabLink.closest('.nav-item');
            const $tabCnt = $tabLink.closest('.nav-tabs');

            isVisible ? $content.removeClass("d-none") : $content.addClass("d-none");
            isVisible ? $tabItem.removeClass("d-none") : $tabItem.addClass("d-none");

            if (focusFirst || (!isVisible && $tabLink.is(".active.show"))) {
                $tabCnt.addClass(`${self.toUpdateClass}`);
            }
        };

        if (viewType == "accordion") {
            $accordionItem = $section.parents('.border-bottom')
            isVisible ? $accordionItem.removeClass("d-none") : $accordionItem.addClass("d-none");
        };

    };
    function getParentData(pInfo) {
        const pData = pInfo ? pInfo.split('#') : [];
        if (pData.length != 2) return null;
        return { id: pData[0], uniqueId: pData[1] };
    };
    function showError(errorMsgs) {
        if (console) console.log(`An error occurred while processing the display rules. ${errorMsgs ? "Errors: " + errorMsgs?.join("; ") : ""}`);
    };
    function updateSectionsData(updSections) {
        updSections.forEach((x, i) => {
            const nid = x.NodeId;
            const sData = self.model.find(rd => nid == rd.NodeId);
            sData.SectionsData = x.SectionsData;
        });
    };
    function getDRules(sid) {
        const item = XPortal.SectionBlock.items[sid];
        return item && item.Display ? JSON.parse(JSON.stringify(item.Display)) : null;
    };
    function getFRules(sid) {
        const item = XPortal.SectionBlock.items[sid];
        return item && item.Formatting ? JSON.parse(JSON.stringify(item.Formatting)) : null;
    };
    function setRequestsAndFieldsNotUpdated() {
        self.model.forEach((x, i) => {
            x.IsUpdated = false;
            x.ModifiedFields.forEach((x, i) => { x.IsUpdated = false; });
        });
    };
    function refreshTimeout(focusFirst, timeMs = 500) {
        clearTimeout(self.processDRTimeout);
        self.processDRTimeout = setTimeout(() => processRules(focusFirst), timeMs);
    };
    function getSectionsData(nodeId) {
        const result = [];
        let $detail = $(`#detail-page-${nodeId}`);
        $detail = $detail.length ? $detail : $(`#dvcontainer_${nodeId}`);
        $detail.find(".xsection[data-edit-type='xdetailssection']").each((ix, x) => {
            const $section = $(x);
            const $sectionBgElement = $section.find('>.xbgdecoration-wrap');
            const id = $section.attr('id');
            const drModel = getDRules(id);
            const frModel = getFRules(id);
            result.push({
                Id: id,
                IsVisible: $section.is(":visible"),
                IsProcessed: false,
                InfluenceFields: [],
                FInfluenceFields: [],
                DInfluenceFields: [],
                ColorCss: "",
                Style: "",
                Classes: "",
                OrgStyle: $sectionBgElement.attr("style"),
                RemoveClasses: "",
                DRModel: drModel,
                FRModel: frModel,
                RelatedFields: [],
                FRelatedFields: [],
                DRelatedFields: []
            });
        });
        return result;
    };
    function getInfluenceFieldsByModel(model) {
        const nid = model.entity.NodeId;
        const uid = model.entity.UniqueId;
        return getInfluenceFields(self.model.filter(x => x.NodeId == nid || x.EntityUId == uid) || []);
    };
    function getInfluenceFields(items) {
        let res = [];
        items.forEach(item => {
            item.SectionsData.forEach((x, i) => {
                if (x.InfluenceFields && x.InfluenceFields.length)
                    res = res.concat(x.InfluenceFields);
            });
        });
        return res;
    };

    return self;
}());